import { decode, encode } from '@here/flexpolyline'
import type { Polygon } from 'geojson'
import { createParser, parseAsFloat } from 'nuqs/server'

const GERMANY_POLYGON_COORDINATES: [number, number][] = [
  [5.98865807458, 47.3024876979],
  [15.0169958839, 47.3024876979],
  [15.0169958839, 54.983104153],
  [5.98865807458, 54.983104153],
  [5.98865807458, 47.3024876979],
]

export const defaultPolygon: Polygon = {
  type: 'Polygon',
  coordinates: [GERMANY_POLYGON_COORDINATES],
}

const polygonCache = new Map<string, Polygon>()

const parseAsPolygon = createParser({
  serialize: (value: Polygon | null): string => {
    if (!value) return ''
    const encoded = encode({ polyline: value.coordinates.flat() })
    return encoded
  },
  parse: (value: string | (string | null)[] | null | undefined): Polygon | null => {
    if (!value || typeof value !== 'string') return null

    if (polygonCache.has(value)) {
      return polygonCache.get(value)!
    }

    try {
      const decoded = decode(value).polyline

      const first = decoded[0]
      const last = decoded[decoded.length - 1]

      const closedPolygon = first[0] === last[0] && first[1] === last[1]

      if (!closedPolygon) {
        // if the polygon is not closed, close it manually
        // this also helps with precision errors from @here/polyline (5 != 5.00001)
        decoded.pop()
        decoded.push(first)
      }

      const polygon: Polygon = {
        type: 'Polygon',
        coordinates: [decoded],
      }
      polygonCache.set(value, polygon)
      return polygon
    } catch {
      return null
    }
  },
})

export const polygonParser = parseAsPolygon.withDefault(defaultPolygon)
export const zoomParser = parseAsFloat.withDefault(10)
